<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/supporters/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          Create new
        </v-btn>
      </v-col>
    </v-row>

    <v-container>
      <v-form ref="searchForm" @submit.prevent="applyFilters">
        <v-row>
          <v-col cols="8" md="11">
            <v-text-field
              v-model="keyword"
              label="Search"
              placeholder="Firstname, lastname, nickname, phone number, etc."
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="4" md="1">
            <v-btn class="mx-2" small type="submit" :loading="loading" :disabled="loading">Search</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="districtMenu"
              :close-on-content-click="false"
              offset-y
              max-height="600"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="district"
                  label="Select District"
                  append-icon="mdi-menu-down"
                  outlined
                  dense
                  readonly
                  clearable
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="district = ''"
                />
              </template>
              <v-list dense class="py-0">
                <v-list-item @click="selectDistrict('')">
                  <v-list-item-title>All District</v-list-item-title>
                </v-list-item>
                <v-list-group
                  v-for="province in districtGroups"
                  :key="province.name"
                  no-action
                  color="primary"
                  class="grey lighten-3"
                >
                  <template v-slot:activator>
                    <v-list-item-title class="font-weight-medium">
                      {{ province.name }} ({{ province.districts.length }})
                    </v-list-item-title>
                  </template>
                  <div class="district-options overflow-y-auto white">
                    <v-list-item
                      v-for="name in province.districts"
                      :key="name"
                      :input-value="district === name"
                      @click="selectDistrict(name)"
                    >
                      <v-list-item-title>{{ name }}</v-list-item-title>
                    </v-list-item>
                  </div>
                </v-list-group>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedJobRoles"
              :items="jobRoles"
              item-text="label"
              item-value="value"
              label="Job role"
              multiple
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="age"
              label="Age"
              type="number"
              min="0"
              max="150"
              step="1"
              :rules="[validAge]"
              outlined
              dense
              clearable
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <app-data-table
      ref="supporterTable"
      :key="search_param"
      :list_name="'supporter'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/supporters`"
      @loading="loading = $event"
    />
  </v-container>
</template>

<script>
import districtGroups from '../districts.json'
import jobRoles from '../job-roles.json'

  export default {
    components: {
      AppDataTable: () => import('../../../components/AppDataTable'),
    },
    name: 'SupporterList',
    data: () => ({
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Code', value: 'internal_code' },
        { text: 'Firstname', value: 'firstname' },
        { text: 'Display name', value: 'display_name' },
        { text: 'Phone number', value: 'phone_number' },
        { text: 'Line ID', value: 'line_id' },
        { text: 'Active', value: 'active' },
        { text: '', value: 'actions', sortable: false }
      ],
    keyword: '',
    loading: true,
    district: '',
    age: '',
    districtMenu: false,
    districtGroups,
    jobRoles,
    selectedJobRoles: [],
      search_param: '',
      attribute_list: ['id', 'internal_code', 'firstname', 'display_name', 'phone_number', 'line_id', 'active'],
    }),
    methods: {
    validAge (value) {
      return value === '' || value == null ||
        (/^\d+$/.test(value) && Number(value) <= 150) ||
        'Enter a whole age between 0 and 150'
    },
    selectDistrict (name) {
      this.district = name
      this.districtMenu = false
    },
    async applyFilters () {
      if (this.loading || !this.$refs.searchForm.validate()) return
      const params = new URLSearchParams()
      if (this.keyword.trim()) params.set('keyword', this.keyword.trim())
      if (this.district) params.set('district', this.district)
      if (this.age !== '' && this.age != null) params.set('age', Number(this.age))
      if (this.selectedJobRoles.length) params.set('job_roles', this.selectedJobRoles.join(','))
      const searchParam = params.toString() ? `&${params}` : ''
      if (searchParam === this.search_param) return this.$refs.supporterTable.getList()
      this.loading = true
      this.search_param = searchParam
      }
    }
  }
</script>

<style scoped>
.district-options {
  max-height: 260px;
}

</style>
